module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "card-footer-item"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": _vm.links.mt4.windows
    }
  }, [_vm._v(_vm._s(_vm.$t('download').tUpper()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "card-footer-item"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": _vm.links.mt4.android + '=' + _vm.Language,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('download').tUpper()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "card-footer-item"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": _vm.links.mt4.ios,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('download').tUpper()))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "card-footer-item"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": _vm.links.mt5.windows
    }
  }, [_vm._v(_vm._s(_vm.$t('download').tUpper()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "card-footer-item"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": _vm.links.mt5.android + '=' + _vm.Language,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('download').tUpper()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "card-footer-item"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": _vm.links.mt5.ios,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('download').tUpper()))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/devices/windows.svg"),
      "alt": "MT4 Windows"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("MT4 Windows")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/devices/android.svg"),
      "alt": "MT4 Android"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("MT4 Android")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/devices/ios.svg"),
      "alt": "MT4 iOS"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("MT4 iOS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/devices/windows.svg"),
      "alt": "MT5 Windows"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("MT5 Windows")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/devices/android.svg"),
      "alt": "MT5 Android"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("MT5 Android")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/devices/ios.svg"),
      "alt": "MT5 iOS"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("MT5 iOS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c26f75"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/TA/Download.vue
// module id = 712
// module chunks = 0